import debounce from "lodash.debounce";
import { unByKey } from "ol/Observable";
import PropTypes from "prop-types";
import { memo, useEffect, useState } from "react";
import { useSelector } from "react-redux";

function Permalink({ history, startUpdating = false }) {
  const mode = useSelector((state) => state.mode);
  const map = useSelector((state) => state.map);
  const debug = useSelector((state) => state.debug);
  const config = useSelector((state) => state.config);
  const [searchParams, setSearchParams] = useState(
    new URLSearchParams(window.location.search),
  );
  const [xyz, setXyz] = useState();

  // Update permalink when mode and debug changes
  useEffect(() => {
    if (!startUpdating || !config) {
      return;
    }
    let reload = false;
    const current = new URLSearchParams(window.location.search);

    // Update permalink when mode changes
    const modeParam = current.get("mode");
    if (modeParam !== mode) {
      current.set("mode", mode);
    }

    // Update debug param when debug changes
    const debugParam = current.get("debug");
    if (debugParam !== debug) {
      if (debug) {
        current.set("debug", debug);
        reload = true;
      } else if (debugParam) {
        current.delete("debug");
        reload = true;
      }
    }

    // Update xyz params when they change
    if (config.xyzParam && !!xyz) {
      if (xyz.get("x") && xyz.get("y") && xyz.get("z")) {
        current.set("x", xyz.get("x"));
        current.set("y", xyz.get("y"));
        current.set("z", xyz.get("z"));
      }
    }

    if (reload) {
      current.set("reload", "true");
    }
    setSearchParams(new URLSearchParams(current));
  }, [mode, startUpdating, config, debug, xyz]);

  // Update permalink when map changes
  useEffect(() => {
    let keys = [];
    if (!startUpdating || !config) {
      return;
    }
    const debounced = debounce(() => {
      const current = new URLSearchParams();
      const [x, y] = map.getView().getCenter() || [];
      const zoom = map.getView().getZoom();
      if (x) {
        current.set("x", `${Math.round(x)}`);
      }
      if (y) {
        current.set("y", `${Math.round(y)}`);
      }
      if (zoom) {
        current.set("z", `${Math.round(zoom * 100) / 100}`);
      }
      setXyz(current);
    }, 500);

    if (config.xyzParam) {
      keys = map?.on("moveend", debounced);
    }
    return () => {
      unByKey(keys);
    };
  }, [map, startUpdating, searchParams, config]);

  useEffect(() => {
    if (
      !startUpdating ||
      !config ||
      window.location.search.replace(/^\?/, "") === searchParams.toString()
    ) {
      return;
    }
    const mustReload = searchParams.get("reload") === "true";
    if (mustReload) {
      searchParams.delete("reload");
    }
    history?.replace(null, searchParams.toString());
    window.top.postMessage(searchParams.toString(), "*");
    if (mustReload) {
      window.location?.reload();
    }
  }, [config, history, searchParams, startUpdating]);

  return null;
}

Permalink.propTypes = {
  history: PropTypes.object.isRequired,
  startUpdating: PropTypes.bool,
};

export default memo(Permalink);
